import { onUnmounted } from 'vue'
import { generateNewsArticleLd, type ArticleSeoData } from '@/utils/jsonld'
import { generateOpenGraphTags } from '@/utils/opengraph'

const JSONLD_ID = 'seo-jsonld'
const OG_PREFIX = 'seo-og-'

export function useSeo(article: ArticleSeoData) {
  const jsonLd = generateNewsArticleLd(article)
  const ogTags = generateOpenGraphTags(article)

  let jsonLdEl = document.getElementById(JSONLD_ID) as HTMLScriptElement | null
  if (!jsonLdEl) {
    jsonLdEl = document.createElement('script')
    jsonLdEl.type = 'application/ld+json'
    jsonLdEl.id = JSONLD_ID
    document.head.appendChild(jsonLdEl)
  }
  jsonLdEl.textContent = JSON.stringify(jsonLd)

  const injectedMetaEls: HTMLMetaElement[] = []

  for (const tag of ogTags) {
    let el = document.querySelector(`meta[property="${tag.property}"]`) as HTMLMetaElement | null
    if (!el) {
      el = document.createElement('meta')
      el.setAttribute('property', tag.property)
      el.dataset.seoInjected = OG_PREFIX + tag.property.replace(/:/g, '-')
      document.head.appendChild(el)
      injectedMetaEls.push(el)
    }
    el.content = tag.content
  }

  document.title = `${article.title} - 升学考试网`

  function cleanup() {
    const jEl = document.getElementById(JSONLD_ID)
    if (jEl) jEl.remove()

    for (const el of injectedMetaEls) {
      if (el.dataset.seoInjected) el.remove()
    }

    document.querySelectorAll(`meta[data-seo-injected^="${OG_PREFIX}"]`).forEach(el => el.remove())
  }

  onUnmounted(cleanup)

  return { cleanup }
}
